
import { defineComponent, reactive, ref } from 'vue'
import { getCurrent, imageUpload, patchPost } from '@/api'
import { useRouter } from 'vue-router'
import Button from '@/components/btn.vue'
import { Post, HTMLInputEvent } from '@/views/Dashboard/Post.vue'
import { useToast } from 'vue-toastification'

export default defineComponent({
  components: {
    Button
  },
  async setup () {
    const router = useRouter()
    const toast = useToast()
    const imageThumb = ref('')
    const imageName = ref('')
    const pageData = reactive({ data: {} as Post })
    const uploadToImgur = async (e: HTMLInputEvent) => {
      try {
        if (!e.target.files) return
        const file: File = e.target.files[0]
        imageName.value = file.name
        imageThumb.value = window.URL.createObjectURL(file)
        const form: FormData = new FormData()
        form.append('title', imageName.value)
        form.append('image', file)
        const { data } = await imageUpload(form)
        if (data.status === 200) {
          toast.success('image uploaded successfully')
          pageData.data.photo = data.data.link
        }
      } catch (error) {
        toast.error('OPPS! something wrong during the process')
      }
    }
    const updateCurrent = async () => {
      const data = {
        title: pageData.data.title,
        article: pageData.data.article,
        photo: pageData.data.photo,
        images: pageData.data.images,
        category: pageData.data.category
      }
      try {
        const res = await patchPost(router.currentRoute.value.params.id as string, data)
        if (res.status === 200) {
          toast.success('Post updated')
          router.replace({ name: 'Post' })
        }
      } catch (error) {
        toast.error(error.response.data.message)
      }
    }
    try {
      const res = await getCurrent(router.currentRoute.value.params.id as string)
      if (res.status === 200) {
        pageData.data = res.data.data
      }
    } catch (error) {
      toast.error(error.response.data.message)
    }
    return {
      pageData,
      uploadToImgur,
      imageThumb,
      updateCurrent
    }
  }
})
